import moment from 'moment'
import { useTranslation } from 'react-i18next';
import { Numeral } from './Numeral';

export const FtxCompletedOrderListItem = (props: any) => {
  const { t } = useTranslation()

  if (props['strategy'] === null) {
    return <></>;
  }

  const token = props['strategy']['product'] ? props['strategy']['product'].split('-')[0].toUpperCase() : null
  const tokenImgPath = `https://ai.supercoin.network/img/coin/${token}.png`

  let status = 'processing'
  switch (props['order']['status']) {
    case 'F':
      status = 'failure'
      break;
    case 'S':
    case 'C':
      status = 'success'
      break;
    default:
  }

  return (
    <>
      <div className="d-flex justify-content-between align-items-end pt-2 text-dark" style={{ "fontSize": "12px" }}>
        <div className="ai-icon bbg">{token ? <img style={{ 'width': '100%' }} src={tokenImgPath} alt="" /> : "無"}</div>
        <div className="d-flex flex-column flex-grow-1">
          <span className="text-dark font-weight-bold" style={{ "fontSize": "14px" }}>
            {props['strategy']['title']} ({props['strategy']['strategy']})
          </span>
          <div>{props['order']['ftxId']}</div>
        </div>
        <div className='mx-2'>
          <span>{t(props['order']['side'] === 'B' ? 'ftxBuy' : 'ftxSell')}</span>
          <div>&nbsp;</div>
        </div>
      </div>
      <div className="d-flex justify-content-between align-items-end pt-2 text-gray-500" style={{ "fontSize": "12px" }}>
        <div className="ai-icon">&nbsp;</div>
        <div className="d-flex flex-column flex-grow-1">
          <span>交易時間：{moment(props['order']['dateAdd']).format('YYYY-MM-DD HH:mm:ss')}</span>
          {props['order']['ftxReservation'] && <div>下單金額：$ <Numeral value={props['order']['ftxReservation']['amount']} /> U (<Numeral value={props['order']['filledSize']} /> {token})</div>}
          {props['order']['pos'] !== 0 && <div>交易價額：$ <Numeral value={props['order']['price']} /></div>}
          {props['order']['coverPrice'] !== 0 && props['order']['pos'] === 0 && <div>平倉價額：$ <Numeral value={props['order']['coverPrice']} /></div>}
          <div>倉位：{props['order']['pos']}</div>
        </div>
      </div>
      <div className="list-hr" style={{ "width": "100%" }}></div>
    </>
  )
}